import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';


@Component({
  selector: 'app-error-modal',
  templateUrl: './error-modal.component.html',
  styleUrls: ['./error-modal.component.scss']
})
export class ErrorModalComponent {
constructor(
    @Inject(MAT_DIALOG_DATA) public data: { errorMessage: string, errorCode: number },
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<ErrorModalComponent>
  ) {}

  closeModal() {

    if(this.data?.errorMessage == 'Session Expired'){

      this.dialogRef.close();

      // this.authService.logout();

    }else{

      this.dialogRef.close();

    }

  }


  ngOnInit(): void {


  }
}
